module.exports = __webpack_public_path__ + "img/tharika-pro.e1db789d.jpg";